// ---------------------------------------------------------------------------
// Audit Log - full detail JSON view
//
// Renders a collapsed JSON dump of the selected entry (auth, timestamps,
// metadata and payloads) for power users who want the raw shape.
// ---------------------------------------------------------------------------

import type { AuditLogEntry } from "@/lib/admin-api/audit-log";

interface DetailJsonViewProps {
  readonly entry: AuditLogEntry;
}

export function DetailJsonView({ entry }: DetailJsonViewProps) {
  const metadata = entry.metadata as Record<string, unknown> | null;

  const detail = {
    id: entry.id,
    admin_user: entry.admin_user?.full_name ?? entry.admin_user_id,
    email: entry.admin_user?.email ?? null,
    action: entry.action,
    resource: entry.resource,
    resource_id: entry.resource_id,
    ip: metadata?.ip ?? null,
    department: metadata?.department ?? null,
    user_agent: metadata?.user_agent ?? null,
    timestamp: entry.created_at,
    before_data: entry.before_data,
    after_data: entry.after_data,
    metadata: entry.metadata,
  };

  return (
    <pre className="max-h-80 overflow-auto rounded-lg bg-stone-900 p-4 text-xs text-stone-200">
      {JSON.stringify(detail, null, 2)}
    </pre>
  );
}
